// Auto-generated by extract-mui-palette.cjs
export type MuiPalette = {
  primary: { 
    main: string; 
    light: string; 
    dark: string; 
    contrastText: string;
    50: string;
    100: string;
    200: string;
    300: string;
    400: string;
    500: string;
    600: string;
    700: string;
    800: string;
    900: string;
  };
  secondary: { 
    main: string; 
    light: string; 
    dark: string; 
    contrastText: string;
    50: string;
    100: string;
    200: string;
    300: string;
    400: string;
    500: string;
    600: string;
    700: string;
    800: string;
    900: string;
  };
  success: { 
    main: string;
    50: string;
    100: string;
    200: string;
    300: string;
    400: string;
    500: string;
    600: string;
    700: string;
    800: string;
    900: string;
  };
  warning: { 
    main: string;
    50: string;
    100: string;
    200: string;
    300: string;
    400: string;
    500: string;
    600: string;
    700: string;
    800: string;
    900: string;
  };
  error: { 
    main: string;
    50: string;
    100: string;
    200: string;
    300: string;
    400: string;
    500: string;
    600: string;
    700: string;
    800: string;
    900: string;
  };
  info: { 
    main: string;
    50: string;
    100: string;
    200: string;
    300: string;
    400: string;
    500: string;
    600: string;
    700: string;
    800: string;
    900: string;
  };
};

const muiPalette: MuiPalette = {
  "primary": {
    "main": "#496c1e",
    "light": "#c1d9a1",
    "dark": "#314714",
    "contrastText": "#ffffff",
    "50": "#f4f9e6",
    "100": "#c1d9a1",
    "200": "#a8cc8a",
    "300": "#8fbf5f",
    "400": "#7db24f",
    "500": "#496c1e",
    "600": "#3d5a19",
    "700": "#314714",
    "800": "#253410",
    "900": "#1e2a0d"
  },
  "secondary": {
    "main": "#6c8f38",
    "light": "#f0f4e8",
    "dark": "#486526",
    "contrastText": "#ffffff",
    "50": "#f8faf5",
    "100": "#f0f4e8",
    "200": "#e8eedb",
    "300": "#e0e8ce",
    "400": "#d8e2c1",
    "500": "#6c8f38",
    "600": "#5a7a2f",
    "700": "#486526",
    "800": "#36501d",
    "900": "#2d4118"
  },
  "success": {
    "main": "#059669",
    "50": "#ecfdf5",
    "100": "#d1fae5",
    "200": "#a7f3d0",
    "300": "#6ee7b7",
    "400": "#34d399",
    "500": "#059669",
    "600": "#047857",
    "700": "#065f46",
    "800": "#064e3b",
    "900": "#064e3b"
  },
  "warning": {
    "main": "#d97706",
    "50": "#fffbeb",
    "100": "#fef3c7",
    "200": "#fde68a",
    "300": "#fcd34d",
    "400": "#fbbf24",
    "500": "#d97706",
    "600": "#d97706",
    "700": "#b45309",
    "800": "#92400e",
    "900": "#78350f"
  },
  "error": {
    "main": "#dc2626",
    "50": "#fef2f2",
    "100": "#fee2e2",
    "200": "#fecaca",
    "300": "#fca5a5",
    "400": "#f87171",
    "500": "#dc2626",
    "600": "#dc2626",
    "700": "#b91c1c",
    "800": "#991b1b",
    "900": "#7f1d1d"
  },
  "info": {
    "main": "#0891b2",
    "50": "#f0f9ff",
    "100": "#e0f2fe",
    "200": "#bae6fd",
    "300": "#7dd3fc",
    "400": "#38bdf8",
    "500": "#0891b2",
    "600": "#0284c7",
    "700": "#0369a1",
    "800": "#075985",
    "900": "#0c4a6e"
  }
};

export default muiPalette;